import { RichTextStyleWrapper } from './richTextStyleWrapper';

export default RichTextStyleWrapper;
